import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Job } from 'server/shared/models/job';
import { JobStatusEnum } from 'server/shared/models/jobStatusEnum';

export type TransferCounts = {
  total: number;
  transferred: number;
  declined: number;
  auto: number;
  nextAutoTransfer: number;
};

@Component({
  selector: 'app-job-list-item-transfers',
  templateUrl: './job-list-item-transfers.component.html',
  styleUrls: ['./job-list-item-transfers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobListItemTransfersComponent implements OnInit {
  job$ = new BehaviorSubject<Job | undefined>(undefined);
  @Input() set job(value: Job | undefined) {
    this.job$.next(value);
  }
  get job() {
    return this.job$.value;
  }

  transferCounts$ = new BehaviorSubject<TransferCounts | undefined>(undefined);
  @Input() set transferCounts(value: TransferCounts | undefined) {
    this.transferCounts$.next(value);
  }
  get transferCounts() {
    return this.transferCounts$.value;
  }

  jobStatusEnum = JobStatusEnum;

  constructor() {}

  ngOnInit(): void {}
}
